export const Attivita_section4 = () => {
    return (
        <div>
            <h3> <img src={"images/centroestivo/loghi/logo_masa.png"} width="35%" style={{"margin-top":"40px"}}/> </h3><h3 className="shadowtext-1bl">Riva Trekking</h3>
            <br />
            <h3><img src={"images/centroestivo/loghi/logo_sportmix2.png"} width="23%"/></h3><h3 className="shadowtext-1bl">Giochi di squadra, <br/> ascolto musicale</h3>
            <br />
           
            
        </div>
    )
}